export default [
  {
    key: 'file',
    label: 'field.video',
    cols: 12,
  },
  {
    key: 'channelId',
    label: 'field.channel',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'channelCock',
    selectionKey: 'id',
    selectionLabel: 'channelName',
    clearable: true,
  },
  {
    key: 'result',
    label: 'field.result',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'betTime',
    label: 'field.betTime',
    rules: 'required|integer',
    type: 'text',
  },
  {
    key: 'fullTime',
    label: 'field.fullTime',
    rules: 'required|integer',
    type: 'text',
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]
